export default __webpack_public_path__ + "static/media/calendar-svgrepo-com.31e33178.svg";